import type {Icon} from '@primer/octicons-react'

import {CustomIcon} from './CustomIcon'

// Fill-only outline of the regridded 16px Octicons ReplyIcon at the approved weight.
export const ReviewChangesRequestedIcon: Icon = props => (
  <CustomIcon {...props} naturalWidth={12} naturalHeight={12}>
    <path d="M5.5667 3.6919 4.5086 4.75l2.6161.0002a2.6188 2.6188 0 0 1 2.5832 2.1544A2.6391 2.6391 0 0 1 9.75 7.3749V8.625a.625.625 0 0 1-.625.625.25.25 0 0 1-.25-.25V7.4254a3.0377 3.0377 0 0 0-.4863-.7798 2.0703 2.0703 0 0 0-.5668-.4638A1.4546 1.4546 0 0 0 7.125 6H4.5086l1.0553 1.0554a.6245.6245 0 0 1 .1928.5129.6247.6247 0 0 1-.0165.0959.25.25 0 0 1-.387.1418L2.5902 5.8438a.25.25 0 0 1-.0319-.0269.6238.6238 0 0 1-.0003-.8825l2.1251-2.1261a.6238.6238 0 1 1 .8825.8819Z" />
  </CustomIcon>
)
